import React from 'react';
import { Container, Row } from 'react-bootstrap';

import { adminApi } from '../../api';
import { hasSuperuserAccess } from '../../utils';
import { SUPERUSER_LEVEL } from '../../constants';

import PageTitle from '../../components/common/PageTitle';
import DisabledOverlay from '../../components/common/DisabledOverlay';
import TransactionList from '../../components/common/transactions/TransactionList';

function Transactions({ t, user }) {
  return (
    <Container className="main-content-container p-3 p-md-5 d-flex flex-column flex-grow-1">
      <Row className="g-0 page-header mb-3 mb-md-5">
        <PageTitle title={t('admin.transactions.title')} backBtn />
      </Row>

      {hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS]) ? (
        <TransactionList
          filterName="transactions"
          hasPermissions={() => hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS])}
          fetchData={adminApi.fetchTransactions}
          generateRowUrl={(row) =>
            `/admin/transaction/${row.uuid || row.original.transaction_uuid}/detail`
          }
        />
      ) : (
        <div className="position-relative">
          <DisabledOverlay />
        </div>
      )}
    </Container>
  );
}

export default Transactions;
